import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from './../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceServant } from '../servants/time/time_occurrence_servant';

function updateTimeCommandDefinition(
  $q: ng.IQService,
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  ngTimeOccurrenceServant: TimeOccurrenceServant,
  QueryMediator: IQueryMediator,
  addBuiltTimeCommand: any,
  deleteTimeCommand: any
) {
  return defineCommand(
    'updateTimeCommand',
    function updateTimeCommand(
      deferred: ng.IDeferred<any>,
      oldTimeBlock: ITimeOccurrenceDatatype,
      propertyHash: Object
    ) {
      const updatedTimeOccurrenceRawData: ITimeOccurrenceDatatype =
        ngTimeOccurrenceServant.copyTimeOccurrenceWithProperties(oldTimeBlock, propertyHash);

      const oldTimeIndex: number = _.findIndex(
        ngTimeOccurrenceDataSource.store,
        (timeBlock: ITimeOccurrenceDatatype) => {
          return timeBlock.trackingId === oldTimeBlock.trackingId;
        }
      );

      const addRawTimePromise: ng.IPromise<any> = addBuiltTimeCommand(updatedTimeOccurrenceRawData, oldTimeIndex);
      const deleteTimePromise: ng.IPromise<any> = deleteTimeCommand(oldTimeBlock);

      $q.all([addRawTimePromise, deleteTimePromise]).then(function (promiseObjects: any) {
        QueryMediator.runQueries(ngTimeOccurrenceDataSource);
        deferred.resolve(promiseObjects[0]);
      });
    }
  );
}

angular.module('ui-ng-calendar').factory('updateTimeCommand', updateTimeCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/update_time.ts